import { action } from 'typesafe-actions';
import {MaintenanceActionTypes, MaintenanceStatusContract} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const fetchMaintenanceStatusRequest = () => action(MaintenanceActionTypes.FETCH_STATUS_REQUEST);
export const fetchMaintenanceStatusSuccess = (maintenanceStatus: MaintenanceStatusContract) => action(MaintenanceActionTypes.FETCH_STATUS_SUCCESS, maintenanceStatus);
export const fetchMaintenanceStatusFailure = (message: string) => action(MaintenanceActionTypes.FETCH_STATUS_FAILURE, message);
